import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { cargarDatosProceso, precalificacionesPrecalificador } from '../../utils/Datos';
import { NavLink } from 'react-router-dom';
import {Toolbar} from '../../layout/Toolbar/Toolbar';
import { InformacionProcesoParticipacion } from "../../components/ProcesosDeCalificacion/InformacionProcesoParticipacion";
import { Tabla } from '../../components/Otros/Tabla';
import { Modal } from '../../components/Otros/Modal';
import { FormularioCalificacion } from "../../components/EtapasDeCalificacion/FormularioCalificacion";

export const PrecalificacionesPrecalificador = () => {

  
  const {id_process,id_officer}=useParams();
  const [datos, setdatos] = useState(null);
  const [updateProceso, setUpdateProceso] = useState(true);
  const [datosProceso, setDatosProceso] = useState(null);
  const [cargandoDatos, setCargandoDatos] = useState(false);
  const [id_precalificacion, setid_precalificacion] = useState(null);


  useEffect(() => {
     
    precalificacionesPrecalificador(id_process,id_officer).then((resultado)=>{
      setdatos(resultado);
      console.log("precalificaciones precalificador",resultado);
    })
    

    cargarDatosProceso(id_process).then((p) => {
      setCargandoDatos(false);
      setDatosProceso(p);
      console.log('proceso',p);
      setUpdateProceso(false);
    });

  }, [])
  
  let toolbarEnlaces = [
    {
      muted: "true",
      to: "/",
      title: "Home",
      bullet: "false",
    },
    {
      muted: "true",
      to: "",
      title: "",
      bullet: "true",
    },
    {
      muted: "false",
      to: '/historialPrecalificaciones',
      title: "Historial de Precalificaciones",
      bullet: "false",
    },
    {
      muted: "true",
      to: "",
      title: "",
      bullet: "true",
    },
    {
      muted: "false",
      to: null,
      title: "Precalificaciones Realizadas",
      bullet: "false",
    },
  ];

  
  return (
    <>
    <div
        className="content d-flex flex-column flex-column-fluid"
        id="kt_content"
    >
        <Toolbar title="Precalificaciones Realizadas" enlaces={toolbarEnlaces}></Toolbar>
        <div className="post d-flex flex-column-fluid" id="kt_post">
        <div className="container-xxl">
            <div className="row gy-5 g-xl-8">
         
              <div className="col-xl-12">
                <div className="card">
                  <div className="card-header">
                    <h3 className="card-title align-items-start flex-column">
                      <span className="card-label fw-bolder text-dark">
                         INFORMACIÓN DEL PROCESO
                      </span>
                    </h3>
                  </div>

                  <div className="card-body">
                    {
                      datosProceso !=null 
                      ?
                      <InformacionProcesoParticipacion
                        key="-editar_proceso"
                        proceso={datosProceso}
                        setUpdateProceso={setUpdateProceso}
                      />
                      :
                      <center>Cargando Proceso...</center>
                    }
                    
                  </div>
                </div>
              </div>
            
              <div className="col-xl-12">
                  <div className="card">
                      <div className="card-body vh-75">
                          <div className='row'>
                              <div className='col-md-12'>
                                
                                  {
                                      datos==null ? <center>Cargando datos...</center> :
                                      <Tabla
                                      columnas={[
                                        {
                                          name: "Etapa",
                                          selector: (row) => (
                                            <span style={{ whiteSpace: "normal" }}>{row.name}</span>
                                          ),
                                          sortable: true,
                                          
                                        },
                                        {
                                          name: "Funcionario",
                                          selector: (row) => (
                                            <span style={{ whiteSpace: "normal" }}>{row.name_officer}</span>
                                          ),
                                          sortable: true,
                                          
                                        },
                                        {
                                          name: "Rut",
                                          selector: (row) => (
                                            <span style={{ whiteSpace: "normal" }}>{row.rut_officer}</span>
                                          ),
                                          sortable: true,
                                          
                                        },
                                        {
                                          name: "Dirección",
                                          selector: (row) => (
                                            <span style={{ whiteSpace: "normal" }}>{row.nameDmunicipal}</span>
                                          ),
                                          sortable: true,
                                          
                                        },
                                        {
                                          name: "Unidad",
                                          selector: (row) => (
                                            <span style={{ whiteSpace: "normal" }}>{row.nameUmunicipal}</span>
                                          ),
                                          sortable: true,
                                          
                                        },
                                        {
                                          name: "Escalafón",
                                          selector: (row) => (
                                            <span style={{ whiteSpace: "normal" }}>{row.scale_officer}</span>
                                          ),
                                          sortable: true,
                                          
                                        },
                                        
                                        {
                                          name: "Grado",
                                          selector: (row) => (
                                            <span style={{ whiteSpace: "normal" }}>{row.grade_officer}</span>
                                          ),
                                          sortable: true,
                                          
                                        },
                                        
                                        
                                        
                                        {
                                          name: "Ver Evaluación",
                                          selector: (row) => (
                                            <button
                                              type="button"
                                              className="btn btn-sm btn-primary"
                                              data-bs-toggle="modal"
                                              data-bs-target={`#modal`}
                                              onClick={() =>
                                                setid_precalificacion(row.id_preQualifications)
                                              }
                                            >
                                              Ver Evaluación
                                            </button>
                                          ),
                                          sortable: false,
                                          minWidth: "150px",
                                        },
                                       
                                      ]}
                                      datos={datos.filter(
                                        (precalificacion) => precalificacion.statusQualificationPre ==true //cambiar a ==true en prod
                                      )}
                                      comparacion={(item, filterText) =>
                                        (item.name_officer &&
                                          item.name_officer
                                            .toLowerCase()
                                            .includes(filterText.toLowerCase())) ||

                                            (item.rut_officer &&
                                              item.rut_officer
                                                .toLowerCase()
                                                .includes(filterText.toLowerCase()))
    

                                      }
                                    ></Tabla>
                                  }
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
            </div>
        </div>
        </div>
    </div>

    <Modal id={`modal`} title={`Evaluación`}>
      {
        id_precalificacion!=null ?
        <>
       
          <FormularioCalificacion
              calificacion={id_precalificacion}
          ></FormularioCalificacion>
        </>
        :
        <>Cargando precalificación</>
      }
        
    </Modal>                             

    </>
  )
}
